module.exports = __webpack_public_path__ + "media/images/camera-c12e5bd4.svg";